// State hub copy and room lists used by the hub page and the prerender.
// Room names are the on-file list. Do not add schedules here.
module.exports = {
  'texas-poker-rooms': {
    title: 'Texas Poker Tournaments Today & Card Rooms | Daily Tourneys',
    h1: 'Texas poker tournaments, poker rooms, and card rooms',
    description: 'Texas poker tournaments today and this week at card rooms near you in Houston, Dallas–Fort Worth, Austin, and San Antonio: start times and buy-ins.',
    intro: 'Find Texas poker tournaments at the state\u2019s card rooms and poker clubs in Houston, Dallas–Fort Worth, Austin, San Antonio, Amarillo, and the Rio Grande Valley. Most Texas poker is played at private social clubs and card houses such as Texas Card House, TCH Social, The Lodge, and Shuffle, which charge a membership or seat fee instead of raking the pot. The one casino poker room on file is Kickapoo Lucky Eagle in Eagle Pass. 23 of the 28 Texas rooms here have a daily or weekly tournament schedule on file. Open a room for contact details, hours, games, and its posted schedule.',
    scheduleCountLine: '23 of the 28 Texas rooms here have a daily or weekly tournament schedule on file.',
    rooms: [
      { name: '101 Poker Club', city: 'Katy', state: 'TX' },
      { name: 'Alamo City Poker Club', city: 'San Antonio', state: 'TX' },
      { name: 'Amarillo Social Club', city: 'Amarillo', state: 'TX' },
      { name: 'Champions Club Texas', city: 'Houston', state: 'TX' },
      { name: 'Champions Social Club', city: 'Dallas', state: 'TX' },
      { name: 'Doghouse Poker Club', city: 'Cypress', state: 'TX' },
      { name: 'Empire Poker Club', city: 'Houston', state: 'TX' },
      { name: 'Kickapoo Lucky Eagle Casino & Hotel', city: 'Eagle Pass', state: 'TX' },
      { name: 'Lonestar Social Poker Club', city: 'Houston', state: 'TX' },
      { name: 'Palace Poker Texas', city: 'Grand Prairie', state: 'TX' },
      { name: 'Paramount Social Club', city: 'Houston', state: 'TX' },
      { name: 'Poker House Fort Worth', city: 'Burleson', state: 'TX' },
      { name: 'Prime Social Club', city: 'Houston', state: 'TX' },
      { name: 'SA Card House', city: 'San Antonio', state: 'TX' },
      { name: 'Shuffle 214', city: 'Dallas', state: 'TX' },
      { name: 'Shuffle 512', city: 'Austin', state: 'TX' },
      { name: 'Spades Poker House Baytown', city: 'Baytown', state: 'TX' },
      { name: 'Spades Poker House Webster', city: 'Webster', state: 'TX' },
      { name: 'TCH Social Austin', city: 'Austin', state: 'TX' },
      { name: 'TCH Social Las Colinas', city: 'Irving', state: 'TX' },
      { name: 'Texas Card House Dallas', city: 'Dallas', state: 'TX' },
      { name: 'Texas Card House Houston', city: 'Houston', state: 'TX' },
      { name: 'Texas Card House Rio Grande Valley', city: 'Edinburg', state: 'TX' },
      { name: 'Texas Card House Spring', city: 'Spring', state: 'TX' },
      { name: 'The Fort Card Room', city: 'Aledo', state: 'TX' },
      { name: 'The Hangar Poker House', city: 'Humble', state: 'TX' },
      { name: 'The Lodge Card Club Round Rock', city: 'Round Rock', state: 'TX' },
      { name: 'The Lodge Card Club San Antonio', city: 'San Antonio', state: 'TX' }
    ]
  },
  'california-poker-rooms': {
    title: 'California Poker Rooms & Tournament Schedules | Daily Tourneys',
    h1: 'California poker rooms and casino tournaments',
    description: 'California cardrooms and casino poker rooms across LA, the Bay Area, and San Diego — contact, hours, and schedules on file.',
    intro: 'Browse California cardrooms and casino poker rooms across Los Angeles, the Bay Area, San Diego, and beyond. Open a room for contact details, hours, games, and daily or weekly tournament schedules where published.',
    rooms: [
      { name: 'Ace & Vine', city: 'Napa', state: 'CA' },
      { name: 'Agua Caliente Casino, Palm Springs', city: '32-250 Bob Hope Drive Rancho Mirage', state: 'CA' },
      { name: 'Artichoke Joes Casino', city: 'San Bruno', state: 'CA' },
      { name: 'Bankers Casino', city: 'Salinas', state: 'CA' },
      { name: 'Barona Resort & Casino', city: 'Lakeside', state: 'CA' },
      { name: 'Bay 101', city: 'San Jose', state: 'CA' },
      { name: 'Bear River Casino Hotel', city: 'Loleta', state: 'CA' },
      { name: 'Black Oak Casino', city: 'Tuolumne', state: 'CA' },
      { name: 'Cache Creek Casino', city: 'Brooks', state: 'CA' },
      { name: 'California Grand Casino', city: 'Pacheco', state: 'CA' },
      { name: 'Capitol Casino', city: 'Sacramento', state: 'CA' },
      { name: 'Casino 99', city: 'Chico', state: 'CA' },
      { name: 'Casino Chico', city: 'Chico', state: 'CA' },
      { name: 'Casino Club', city: 'Redding', state: 'CA' },
      { name: 'Casino M8trix', city: 'San Jose', state: 'CA' },
      { name: 'Central Coast Casino', city: 'Grover Beach', state: 'CA' },
      { name: 'Club One Casino', city: 'Fresno', state: 'CA' },
      { name: 'Club San Rafael', city: 'San Rafael', state: 'CA' },
      { name: 'Commerce Casino', city: 'Commerce', state: 'CA' },
      { name: 'Crystal Casino', city: 'Compton', state: 'CA' },
      { name: 'Diamonds Jims Casino', city: 'Rosamond', state: 'CA' },
      { name: 'El Dorado Hills Casino', city: 'El Dorado Hills', state: 'CA' },
      { name: 'Empire Sportsmen Association', city: 'Modesto', state: 'CA' },
      { name: 'Garlic City Casino & Restaurant', city: 'Gilroy', state: 'CA' },
      { name: 'Golden West Casino', city: 'Bakersfield', state: 'CA' },
      { name: 'Graton Resort & Casino', city: 'Rohnert Park', state: 'CA' },
      { name: 'Hollywood Park Casino', city: 'Inglewood', state: 'CA' },
      { name: 'Hustler Casino', city: 'Gardena', state: 'CA' },
      { name: 'Isleton Casino', city: 'Isleton', state: 'CA' },
      { name: 'Jackson Rancheria Casino', city: 'Jackson', state: 'CA' },
      { name: 'Kings Card Club', city: 'Stockton', state: 'CA' },
      { name: 'Lake Elsinore Hotel & Casino', city: 'Lake Elsinore', state: 'CA' },
      { name: 'Jamul Casino Resort', city: 'Jamul', state: 'CA' },
      { name: 'Larry Flynt\'s Lucky Lady Casino', city: 'Gardena', state: 'CA' },
      { name: 'Limelight Cardroom', city: 'Sacramento', state: 'CA' },
      { name: 'Livermore Casino', city: 'Livermore', state: 'CA' },
      { name: 'Lucky Chances', city: 'Colma', state: 'CA' },
      { name: 'Merced Poker Room', city: 'Merced', state: 'CA' },
      { name: 'Napa Valley Casino', city: 'American Canyon', state: 'CA' },
      { name: 'Nineteenth Hole', city: 'Antioch', state: 'CA' },
      { name: 'North Coast Casino', city: 'Eureka', state: 'CA' },
      { name: 'Oaks Card Club', city: 'Emeryville', state: 'CA' },
      { name: 'Ocean\'s 11 Casino', city: 'Oceanside', state: 'CA' },
      { name: 'Oceanview Card Room', city: 'Santa Cruz', state: 'CA' },
      { name: 'Outlaws Card Parlour', city: 'Atascadero', state: 'CA' },
      { name: 'Palace Poker Casino', city: 'Hayward', state: 'CA' },
      { name: 'Parkwest Casino Cordova', city: 'Rancho Cordova', state: 'CA' },
      { name: 'Parkwest Casino Lodi', city: 'Lodi', state: 'CA' },
      { name: 'Parkwest Casino Manteca', city: 'Manteca', state: 'CA' },
      { name: 'Players Casino', city: 'Ventura', state: 'CA' },
      { name: 'Seven Mile Casino', city: 'Chula Vista', state: 'CA' },
      { name: 'Stars Casino', city: 'Tracy', state: 'CA' },
      { name: 'Stones Gambling Hall', city: 'Citrus Heights', state: 'CA' },
      { name: 'Sycuan Casino', city: 'El Cajon', state: 'CA' },
      { name: 'The Aviator Casino', city: 'Delano', state: 'CA' },
      { name: 'The Bicycle Hotel & Casino', city: 'Bell Gardens', state: 'CA' },
      { name: 'The Clovis 500 Club', city: 'Clovis', state: 'CA' },
      { name: 'The Gardens Casino', city: 'Hawaiian Gardens', state: 'CA' },
      { name: 'The Marina Club Casino', city: 'Marina', state: 'CA' },
      { name: 'Thunder Valley Casino', city: 'Lincoln', state: 'CA' },
      { name: 'Towers Casino & Card Room', city: 'Grass Valley', state: 'CA' },
      { name: 'Turlock Poker Room', city: 'Turlock', state: 'CA' },
      { name: 'Westlane Card Room', city: 'Stockton', state: 'CA' }
    ]
  },
  'washington-poker-rooms': {
    title: 'Washington Poker Rooms & Tournament Schedules | Daily Tourneys',
    h1: 'Washington poker rooms and casino tournaments',
    description: 'Washington card rooms and casino poker rooms across Seattle, Tacoma, and Spokane — contact, hours, and schedules on file.',
    intro: 'Find Washington commercial card rooms and casino poker rooms across the Seattle area, Tacoma, Spokane, and beyond. Open a room for contact details, hours, games, and regular tournament schedules where published.',
    rooms: [
      { name: 'Ace\'s Poker Lakewood', city: 'Lakewood', state: 'WA' },
      { name: 'Ace\'s Poker Mountlake Terrace', city: 'Mountlake Terrace', state: 'WA' },
      { name: 'All Star Casino', city: 'Silverdale', state: 'WA' },
      { name: 'Black Pearl Restaurant & Card Room', city: 'Spokane Valley', state: 'WA' },
      { name: 'Broadway Grill & Pizzeria', city: 'Everett', state: 'WA' },
      { name: 'Buzz Inn Steakhouse East Wenatchee', city: 'East Wenatchee', state: 'WA' },
      { name: 'Caribbean Cardroom', city: 'Kirkland', state: 'WA' },
      { name: 'Casino Caribbean Kirkland', city: 'Kirkland', state: 'WA' },
      { name: 'Casino Caribbean Yakima', city: 'Yakima', state: 'WA' },
      { name: 'Clearwater Saloon & Casino', city: 'East Wenatchee', state: 'WA' },
      { name: 'Crazy Moose Casino Pasco', city: 'Pasco', state: 'WA' },
      { name: 'Fortune Casino La Center', city: 'La Center', state: 'WA' },
      { name: 'Fortune Casino Lacey', city: 'Lacey', state: 'WA' },
      { name: 'Fortune Casino Renton', city: 'Renton', state: 'WA' },
      { name: 'Fortune Poker Renton', city: 'Renton', state: 'WA' },
      { name: 'Imperial Palace Casino Auburn', city: 'Auburn', state: 'WA' },
      { name: 'Jamestown Saloon', city: 'Arlington', state: 'WA' },
      { name: 'Joker\'s Casino and Sports Bar', city: 'Richland', state: 'WA' },
      { name: 'Lancer Lanes and Casino', city: 'Clarkston', state: 'WA' },
      { name: 'Lilac Lanes & Casino', city: 'Spokane', state: 'WA' },
      { name: 'Little Creek Casino Resort', city: 'Shelton', state: 'WA' },
      { name: 'Northern Quest Resort & Casino', city: 'Airway Heights', state: 'WA' },
      { name: 'Palace Casino Lakewood', city: 'Lakewood', state: 'WA' },
      { name: 'Razzals Bar & Grill', city: 'Lake Stevens', state: 'WA' },
      { name: 'Roxbury Lanes Casino', city: 'Seattle', state: 'WA' },
      { name: 'Slo Pitch Pub & Eatery', city: 'Bellingham', state: 'WA' }
    ]
  },
  'florida-poker-rooms': {
    title: 'Florida Poker Rooms & Tournament Schedules | Daily Tourneys',
    h1: 'Florida poker rooms and casino tournaments',
    description: 'Florida poker rooms and casino tournaments across Jacksonville, Miami, Tampa Bay, and Orlando — contact, hours, and schedules on file.',
    intro: 'Find Florida poker rooms and casino tournament schedules across Jacksonville, Miami, Tampa Bay, Orlando, and beyond. Open a room for contact details, hours, games, and daily or weekly schedules where published.',
    rooms: [
      { name: 'Bestbet, Orange Park', city: 'Orange Park', state: 'FL' },
      { name: 'Calder Casino', city: 'Miami Gardens', state: 'FL' },
      { name: 'Casino Miami', city: 'Miami', state: 'FL' },
      { name: 'Club 52 Poker at Melbourne Greyhound Park', city: 'Melbourne', state: 'FL' },
      { name: 'Creek Entertainment Gretna', city: 'Gretna', state: 'FL' },
      { name: 'Daytona Beach Kennel Club & Poker Room, Williamson Blvd', city: 'Daytona Beach', state: 'FL' },
      { name: 'Derby Lane Poker Room', city: 'St. Petersburg', state: 'FL' },
      { name: 'Ebro Poker Room', city: 'Ebro', state: 'FL' },
      { name: 'Fort Pierce Poker &  Jai-Alai', city: 'Fort Pierce', state: 'FL' },
      { name: 'Gulfstream Park Racing & Casino', city: 'Hallandale Beach', state: 'FL' },
      { name: 'Harrah\'s Pompano Beach', city: 'Pompano Beach', state: 'FL' },
      { name: 'Hialeah Park Casino', city: 'Hialeah', state: 'FL' },
      { name: 'Lucky\'s Card Room (TGT Poker)', city: 'Tampa', state: 'FL' },
      { name: 'Magic City Casino', city: 'Miami', state: 'FL' },
      { name: 'Miccosukee Resort & Gaming', city: 'Miami', state: 'FL' },
      { name: 'Naples Fort Myers Kennel Club & Poker Room', city: 'Bonita Springs', state: 'FL' },
      { name: 'Ocala Bets', city: 'Ocala', state: 'FL' },
      { name: 'Ocala Poker & Jai-Alai', city: 'Orange Lake', state: 'FL' },
      { name: 'One-Eyed Jack\'s Poker Room', city: 'Sarasota', state: 'FL' },
      { name: 'Orange City Racing and Card Club', city: 'Orange City', state: 'FL' },
      { name: 'Oxford Downs', city: 'Summerfield', state: 'FL' },
      { name: 'Palm Beach Kennel Club, West Palm Beach', city: 'West Palm Beach', state: 'FL' },
      { name: 'Pensacola Greyhound Park Poker Room', city: 'Pensacola', state: 'FL' },
      { name: 'Seminole Casino Hotel, Immokalee', city: 'Immokalee', state: 'FL' },
      { name: 'Seminole Casino, Coconut Creek', city: 'Coconut Creek', state: 'FL' },
      { name: 'Seminole Hard Rock Hotel & Casino, Hollywood', city: 'Hollywood', state: 'FL' },
      { name: 'Seminole Hard Rock Hotel & Casino, Tampa', city: 'Tampa', state: 'FL' },
      { name: 'Tampa Bay Downs', city: 'Tampa', state: 'FL' },
      { name: 'The Big Easy Casino', city: 'Hallandale Beach', state: 'FL' },
      { name: 'The Casino @ Dania Beach', city: 'Dania Beach', state: 'FL' },
      { name: 'bestbet Jacksonville', city: 'Jacksonville', state: 'FL' },
      { name: 'bestbet St. Augustine', city: 'St. Augustine', state: 'FL' }
    ]
  }
};



// WEBPACK FOOTER //
// ./js/state-hubs.js